import { render, staticRenderFns } from "./OrdersMainChart.vue?vue&type=template&id=4a691bde&scoped=true&"
import script from "./OrdersMainChart.vue?vue&type=script&lang=js&"
export * from "./OrdersMainChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a691bde",
  null
  
)

export default component.exports